if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}

function createAlertPopover(containerId, isSwatch = false, alertDataSwatch = {}) {

  const container = document.getElementById(containerId);
  if (!container) {
    console.error("Element with that ID not found:", containerId);
    return;
  }
  if (container.childElementCount > 0 && alertDataSwatch  ) return

  container.innerHTML = ''
  const alertDataStr = container.dataset.alertData;
  let alertData;
  if (!isSwatch) {
    try {
      alertData = JSON.parse(alertDataStr);
      container.style.height = '5rem'
    } catch (e) {
      console.error("Error al parsear alertData:", e);
      return;
    }
  } else {
    if (alertDataSwatch) {
      alertData = JSON.parse(alertDataSwatch); 
      container.style.height = '5rem'
    } else {
      container.style.height = '0'
      return
    }
  }


  const alertSvg = `<svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 24 24" fill="none" stroke="${alertData.text_color}" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
    <circle cx="12" cy="12" r="10"></circle>
    <line x1="12" y1="16" x2="12" y2="12"></line>
    <line x1="12" y1="8" x2="12.01" y2="8"></line>
  </svg>`

  const alertEl = document.createElement('div');
  alertEl.className = 'alert pot_alert';
  alertEl.innerHTML = `${alertData.alert } ${alertSvg}`;
  alertEl.style.backgroundColor = alertData.background_color;
  alertEl.style.color = alertData.text_color;
  alertEl.style.padding = '10px';
  alertEl.style.margin = '10px 0';
  alertEl.style.cursor = 'pointer';
  alertEl.style.position = 'relative'; 
  const popoverBtn = document.createElement('button');
  popoverBtn.innerHTML = `<svg class="svg_popover" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M12.6693 4.27203L11.7293 3.33203L8.0026 7.0587L4.27594 3.33203L3.33594 4.27203L7.0626 7.9987L3.33594 11.7254L4.27594 12.6654L8.0026 8.9387L11.7293 12.6654L12.6693 11.7254L8.9426 7.9987L12.6693 4.27203Z" fill="black"/>
  </svg>`
  popoverBtn.className = 'popover_button';
  const popoverEl = document.createElement('div');
  popoverEl.className = 'alert-popover';
  popoverEl.style.display = 'none';
  popoverEl.style.position = 'absolute';
  popoverEl.style.top = '100%';
  popoverEl.style.left = '0';
  popoverEl.style.backgroundColor = alertData.background_color;
  popoverEl.style.setProperty('--popover-bg', alertData.background_color);
  popoverEl.style.color = alertData.text_color;
  popoverEl.style.padding = '16px';
  popoverEl.style.marginTop = '10px';
  popoverEl.style.zIndex = '1000';
  popoverEl.innerHTML = `<span class="popover_title"><strong>${alertData.alert_title}</strong></span>${alertData.alert_description}`;
  popoverEl.childNodes[0].appendChild(popoverBtn);
  alertEl.appendChild(popoverEl);
  alertEl.addEventListener('click', function () {
    popoverEl.style.display = popoverEl.style.display === 'none' ? 'block' : 'none';
  });
  container.appendChild(alertEl);
}

createAlertPopover("alert-container_mobile");
createAlertPopover("alert-container_desktop");
